import { useEffect } from 'react';
import { getCookie } from 'utils/common.util';
import useSpecialPackagesStore from 'store/specialPackage';
import useShareholdersStore from 'store/shareholders';
import useFundamentalStore from 'store/fundamental';
import useMarketWatchStore from 'store/watchlist';
import useSecurityStore from 'store/security';
import useProfileStore from 'store/profile';
import useNavStore from 'store/nav';

const useLogout = (): void => {
  const restSpecialPackages = useSpecialPackagesStore((state) => state.reset);
  const restShareholders = useShareholdersStore((state) => state.reset);
  const restMarketWatch = useMarketWatchStore((state) => state.reset);
  const restFundamental = useFundamentalStore((state) => state.reset);
  const restSecurity = useSecurityStore((state) => state.reset);
  const restProfile = useProfileStore((state) => state.reset);
  const restNav = useNavStore((state) => state.reset);
  const refresh = getCookie('pwa_refresh_token');
  const access = getCookie('pwa_access_token');

  useEffect(() => {
    if (!refresh || !access) {
      restProfile();
      restFundamental();
      restShareholders();
      restSpecialPackages();
      restSecurity();
      restMarketWatch();
      restNav();
    }
  }, [access, refresh]);
};

export default useLogout;
